import BuscaTypes from './types';

export const clear = () => ({
  type: BuscaTypes.CLEAR,
});

export const searchRequest = (filtros) => ({
  type: BuscaTypes.SEARCH_REQUEST,
  payload: filtros,
});

export const searchTotais = () => ({
  type: BuscaTypes.SEARCH_TOTAIS_REQUEST,
});

export const searchFailure = () => ({
  type: BuscaTypes.SEARCH_FAILURE,
});

export const searchSuccess = (protocolos) => ({
  type: BuscaTypes.SEARCH_SUCCESS,
  payload: protocolos,
});

export const searchTotaisSuccess = (data) => ({
  type: BuscaTypes.SEARCH_TOTAIS_SUCCESS,
  payload: data,
});

export const searchFiltersSuccess = (data) => ({
  type: BuscaTypes.SEARCH_FILTERS_SUCCESS,
  payload: data,
});

export const loadFilterRequest = (filtros) => ({
  type: BuscaTypes.LOAD_FILTER_REQUEST,
  payload: filtros,
});

export const loadFilterFailure = () => ({
  type: BuscaTypes.LOAD_FILTER_FAILURE,
});

export const searchDinamicFiltersSuccess = (data) => ({
  type: BuscaTypes.SEARCH_FILTERS_SUCCESS,
  payload: data,
});

export const searchDinamicFiltersRequest = (name) => ({
  type: BuscaTypes.SEARCH_FILTERS_REQUEST,
  payload: name,
});

export const searchDinamicFiltersFailure = () => ({
  type: BuscaTypes.SEARCH_FILTERS_FAILURE,
});
